import { NodeSSH } from 'node-ssh'
import { SshConfig } from '../../configuration/interface'

export const getSsh = async (sshConfig: SshConfig) => {
  const ssh = new NodeSSH()
  await ssh.connect(sshConfig)
  return ssh
}